import React, {useState, useEffect, useContext, useRef} from "react";
import {useParams} from "react-router-dom";
import ListPanel from '../administration/components/ListPanel';
import EditPanel from '../administration/components/EditPanel';
import {useHistory} from 'react-router-dom';
import {store} from '../../context/store';
import {INPUT_TYPE_TEXT} from "../../constants/input-types";
import {INPUT_TYPE_TEXTAREA} from "../../constants/input-types";
import {INPUT_TYPE_SELECT} from "../../constants/input-types";
import {INPUT_TYPE_SELECTFROMDB} from "../../constants/input-types";
import {functions} from "../../constants/common-functions";
import {STRINGIFY} from "../../constants/general-constants";
import AdminListPanelClassificationItems from '../administration/components/AdminListPanelClassificationItems';
import EditButtonPanel from '../administration/components/EditButtonPanel';
import {YES_NO_OPTIONS} from "../../constants/general-constants";
import {APPLIES_TO_OPTIONS} from "../../constants/general-constants";
import {DEFAULT_BLUE} from "../../constants/general-constants";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";

export default function AdministrationClassificationsEdit(){
	
	const globalState = useContext(store);
	const history = useHistory(); 
	const [entityCode, setEntityCode] = useState("");
	const [entityName, setEntityName] = useState("New Classification");
	const [entityDescription, setEntityDescription] = useState("");
	
	const refCode = useRef(null);
	const refName = useRef(null);
	const refAppliesTo = useRef(null);
	const refIsDivision = useRef(null);
	const refIsSpaceType = useRef(null);
	
	const id = useParams()["id"];
	
	useEffect(() => {
		functions.getObjectFromAjax("/resolution/classification?id=" + id, null, initialiseFields);
	}, []);
	
	const getEntityCode = () => {
		return refCode.current.value;
	};
	
	const getEntityName = () => {
		return refName.current.value;
	};
	
	const initialiseFields = (entity) => {
		try{
			let isDivisionValue = "N";
			if(entity.isDivision === true){
				isDivisionValue = "Y";
			}
			let isSpaceTypeValue = "N";
			if(entity.isSpaceType === true){
				isSpaceTypeValue = "Y";
			}
			setEntityCode(entity.code);
			setEntityName(entity.name);
			refCode.current.value = entity.code;
			refName.current.value = entity.name;
			refAppliesTo.current.value = entity.appliesTo;
			refIsDivision.current.value= isDivisionValue;
			refIsSpaceType.current.value = isSpaceTypeValue;
		}
		catch(e){}
		
	};
	
	const mainComponentRows = [
		{ref:refCode, id:"1", title:"Code", inputType:INPUT_TYPE_TEXT},
		{ref:refName, id:"2", title:"Name", inputType:INPUT_TYPE_TEXT},
		{ref:refAppliesTo, id:"3", title:"Applies To", inputType:INPUT_TYPE_SELECT, options:APPLIES_TO_OPTIONS},
		{ref:refIsDivision, id:"4", title:"Is Divisional Classification?", inputType:INPUT_TYPE_SELECT, options:YES_NO_OPTIONS},
		{ref:refIsSpaceType, id:"5", title:"Is Space Classification?", inputType:INPUT_TYPE_SELECT, options:YES_NO_OPTIONS}
	];
	
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 60px)",
		minHeight:"100vh",
		backgroundColor:"white",
		flexDirection:"column",
		//overflow:"auto",
		paddingBottom:"100px",
		marginLeft:"60px",
		marginTop:"60px"
	};
	
	const administrationHeader = {
		display:"flex",
		height:"60px",
		paddingLeft:"20px",
		alignItems:"center",
		color:"black"
	};
	
	const contentPanel = {
		display:"flex",
		width:"100%"
	};
	
	
	const getSubmitObject = () => {
		let isDivisionValue = false;
		if(refIsDivision.current.value === "Y"){
			isDivisionValue = true;
		}
		let isSpaceTypeValue = false;
		if(refIsSpaceType.current.value === "Y"){
			isSpaceTypeValue = true;
		}
		
		let submitObject = {
			id:id,
			code:refCode.current.value,
			name:refName.current.value,
			parentId:"0",
			appliesTo:refAppliesTo.current.value,
			isDivision:isDivisionValue,
			isSpaceType:isSpaceTypeValue
		};
		console.log("CLASSIFICATION SUBMIT");
		console.log(submitObject);
		return submitObject
	}
	
	const goSubmit = () => {
		
		functions.submitAjax("/resolution/classificationsave", 
				getSubmitObject(), saveEnd,  STRINGIFY, handleSubmitError);
		
	};
	
	const handleSubmitError = (e) => {
		console.log(e);
	};
	
	const saveEnd = () => {
		goCancel();
	};
	
	const goDelete = () => {
		functions.submitAjax("/resolution/classificationdelete", 
				getSubmitObject(), saveEnd,  STRINGIFY, handleSubmitError);
	};
	
	const goCancel = () => {
		history.goBack();
	};

	return (
		
			<div style={thisContainer}>
			<Header/>
				<LeftMenu/>
				<div style={administrationHeader}>
					Classification Edit: {entityName}
				</div>
				<div style={contentPanel}>
					<EditPanel
					title="Main Details"
						componentRows = {mainComponentRows}
					/>
					<AdminListPanelClassificationItems
					id={id}
					/>
				</div>
				<EditButtonPanel
					id={id}
					goSubmit={goSubmit}
					goDelete={goDelete}
					goCancel={goCancel}
					checkCodeUrl="classifications"
					getCodeFunction={getEntityCode}
					getNameFunction={getEntityName}
				/>
			</div>
			
	
	);
}